import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/trash.svg',
})
export class TrashComponent {}
